import script from "./AddOnhireMainComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddOnhireMainComponent.vue?vue&type=script&setup=true&lang=js"

import "./AddOnhireMainComponent.vue?vue&type=style&index=0&id=1cc04246&lang=css"

const __exports__ = script;

export default __exports__